export default __webpack_public_path__ + "static/media/broadcast_announce.7df2e5c9.jpg";